import { PairedSalesStudy } from '@aloft/toolkit-shared';
import { Block } from '@aloft/toolkit-sui';

import { StudyList } from './components/StudyList.js';

import './StudiesModule.scss';

export const StudiesModule = ({ studies }: { studies: PairedSalesStudy[] }) => {
  return (
    <Block className="studies-module" height="100%" width="100%" overflow="hidden">
      <StudyList studies={studies} />
    </Block>
  );
};
